"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.max = exports.min = exports.maxLength = exports.minLength = exports.isDecimal = exports.isInt = void 0;
const InputValidationError_1 = require("./InputValidationError");
const intValidationRegex = /^((?:-)?\d+)$/;
function isInt(value, errorMessage) {
    if (intValidationRegex.test(value)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.isInt = isInt;
const decimalValidationRegex = /^((?:-)?\d+\.\d+)$/;
function isDecimal(value, errorMessage) {
    if (decimalValidationRegex.test(value)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.isDecimal = isDecimal;
function minLength(value, errorMessage, param) {
    if (value.length >= parseInt(param)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.minLength = minLength;
function maxLength(value, errorMessage, param) {
    if (value.length <= parseInt(param)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.maxLength = maxLength;
function min(value, errorMessage, param) {
    if (parseInt(value) >= parseInt(param)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.min = min;
function max(value, errorMessage, param) {
    if (parseInt(value) <= parseInt(param)) {
        return;
    }
    throw new InputValidationError_1.default(errorMessage);
}
exports.max = max;
